import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { EditUserVS } from 'shared/utils/validation/AuthValidation';
import styles from '../user_add/style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import Select from 'react-select';
import UploadAvatar from 'shared/components/common/upload_avatar/UploadAvatar';
import { uploadFileMedia } from 'shared/services/media_service/Media_Service';
import { RoleList } from '../user_add/Constant';

export default function UserEditModal({ show, handleClose, submitEditUser, editUser, isLoading }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [avatarFile, setAvatarFile] = useState(null);
    const [selectedImg, setSelectedImg] = useState('');

    useEffect(() => {
        if (editUser) {
            setSelectedImg(editUser?.profile_image || '');
            setAvatarFile(null);
        }
    }, [editUser, show]);

    const initialValues = {
        username: editUser?.name || '',
        email: editUser?.email || '',
        password: editUser?.visiblePass || '',
        authorize: RoleList.find((r) => r.value === editUser?.authorize) || (editUser?.authorize ? { label: editUser?.authorize, value: editUser?.authorize } : null)
    };

    const uploadMedia = async () => {
        try {
            let fileBody = new FormData();
            fileBody.append('image', avatarFile);
            return await uploadFileMedia(fileBody);
        } catch (error) { }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: EditUserVS,
        onSubmit: async (value) => {
            let userDetail = {
                name: value.username,
                email: value.email,
                authorize: value.authorize?.value || value.authorize
            };
            if (value.password && value.password.trim().length > 0) {
                userDetail.password = value.password;
            }
            if (typeof avatarFile !== 'string' && avatarFile) {
                let resp = await uploadMedia();
                if (resp?.data) {
                    userDetail['profile_image'] = resp?.data?.url;
                }
            } else if (selectedImg) {
                userDetail['profile_image'] = selectedImg;
            }

            submitEditUser({ id: editUser?._id, data: userDetail });
            handleClose();
        }
    });

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Edit User'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <UploadAvatar UploadedFile={avatarFile} setFile={setAvatarFile} selectedImg={selectedImg} setSelectedImg={setSelectedImg} />

                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomInput
                        label={'User Name'}
                        placeholder={'e.g. John'}
                        type="text"
                        value={values.username}
                        onChange={(e) => {
                            setFieldValue('username', e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.username && touched.username ? errors.username : ''}
                    />
                    <CustomInput
                        label={'Email'}
                        type={'email'}
                        placeholder={'e.g. john@example.com'}
                        value={values.email}
                        onChange={(e) => {
                            setFieldValue('email', e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.email && touched.email ? errors.email : ''}
                    />
                    <CustomInput
                        label={'Password'}
                        type={'text'}
                        placeholder={'Enter new password (or leave as is)'}
                        value={values.password}
                        onChange={(e) => {
                            setFieldValue('password', e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.password && touched.password ? errors.password : ''}
                    />
                    <label className="LightFontColor Label style_InputLabel__lhse5">Role</label>
                    <Select
                        className={values.brand ? '' : classNames(styles.disable)}
                        options={RoleList}
                        isSearchable
                        isClearable
                        value={values.authorize}
                        placeholder="Select Role"
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        onChange={(item) => {
                            setFieldValue('authorize', item);
                        }}
                    />
                    <div className="Error"> {errors.authorize && touched.authorize ? errors.authorize : ''}</div>

                    <div className="d-flex justify-content-end mt-4">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton
                            text={'Update User'}
                            containerStyle={styles.SubmitBtn}
                            submitHandle={() => {
                                handleSubmit();
                            }}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
